import { useState, useEffect } from "react";
import { getSearchBackUrl } from "../utils";
import { searchMachines } from "../api/search/searchApi";
import { refactorSearchMachinesData } from "../services/SearchServices";
import { getUrl } from "../utils";
import { API_SEARCH_MACHINES_SEARCH } from "../constants/api";
import _ from "lodash";
import { clearComponentLoading, setComponentLoading } from "../store/actions";
import { useDispatch } from "react-redux";

const useSearchHook = (params) => {
  const [totalCount, setTotalCount] = useState(0);
  const [machines, setMachines] = useState([]);
  const [searchInformation, setSearchInformation] = useState();
  const dispatch = useDispatch();

  useEffect(() => {
    if (_.isEmpty(params)) {
      return;
    }
    dispatch(setComponentLoading("search_machine"));
    searchMachines(getUrl(params, API_SEARCH_MACHINES_SEARCH))
      .then((response) => {
        setMachines(refactorSearchMachinesData(response.data.machines));
        setSearchInformation(response.data.search_information);
        setTotalCount(response.data.pagination.total_count);
      })
      .catch((e) => {
        window.location.href = getSearchBackUrl(params, "machine");
      })
      .finally(() => {
        dispatch(clearComponentLoading("search_machine"));
      });
  }, [params]);

  return {
    totalCount,
    machines,
    searchInformation,
    setTotalCount,
    setMachines,
    setSearchInformation,
  };
};

export { useSearchHook };
